<template>
  <v-card disabled flat>
    <div style="position:relative;">
      <h3 style="margin:15px;text-align:center;">
        Store Address
        <v-btn
          icon
          absolute
          v-if="!isEditStoreList"
          @click="editAddress()"
          style="top:-5px;right:15px;"
        >
          <v-icon color="black">edit</v-icon>
        </v-btn>
      </h3>
      <hr style="margin:0 15px;" />
      <editStoreAddress
        :loading="loading"
        @cancelEditAddress="cancelEditAddress()"
        @saveEditAddress="saveEditAddress()"
        :dialog="address_dialog"
        @setDialog="address_dialog = $event"
        :edit_form="edit_form"
        @change="change=change+1"
      />

      <v-card-text>
        <v-tabs-items v-model="tabs.info">
          <v-tab-item v-for="n in lang" :key="n" transition="fade" reverse-transition="fade">
            <div style="padding-top:1px;background-color:#eeeeee;">
              <v-layout row>
                <v-flex>
                  <div class="style-title-detail">
                    Address :
                    <span
                      class="style-data-detail"
                    >{{store_detail.store['store_address_' + n ]}}</span>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-tab-item>
        </v-tabs-items>
        <div class="style-title-detail">
          Zone :
          <span class="style-data-detail">{{store_detail.store_zone}}</span>
        </div>
        <div class="style-title-detail">
          Province :
          <span
            class="style-data-detail"
          >{{store_detail.store_province['province_name_th']}}</span>
        </div>
        <div class="style-title-detail">
          district :
          <span
            class="style-data-detail"
          >{{store_detail.store_district['district_name_th']}}</span>
        </div>
        <div class="style-title-detail">
          Sub district :
          <span
            class="style-data-detail"
          >{{store_detail.store_sub_district.sub_district_name_th}}</span>
        </div>
        <div class="style-title-detail">
          Post code :
          <span class="style-data-detail">{{ store_detail.store_zipcode.zipcode_code}}</span>
        </div>
        <div class="style-title-detail">
          Place note :
          <span class="style-data-detail">{{ store_detail.store.store_note}}</span>
        </div>
        <div class="style-title-detail">
          latitude :
          <span class="style-data-detail">{{ store_detail.store.store_lat }}</span>
        </div>
        <div class="style-title-detail">
          longitude :
          <span class="style-data-detail">{{ store_detail.store.store_long }}</span>
        </div>
        <v-card height="255px" width="auto" color="white">
          <GoogleMap
            :change="change"
            :height="250"
            :zoom="15"
            :latitude="parseFloat(store_detail.store.store_lat)"
            :longitude="parseFloat(store_detail.store.store_long)"
            :mapType="'latandlong'"
          ></GoogleMap>
        </v-card>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import editStoreAddress from "../EditStore/EditStoreAddress";
import { mapGetters } from "vuex";
export default {
  props: ["tabs", "store_detail"],
  components: {
    editStoreAddress
  },
  data() {
    return {
      change: 0,
      address_dialog: false,
      lang: ["th", "en", "cn"],
      edit_form: null,
      loading: true
    };
  },
  computed: {
    ...mapGetters(["isEditStoreList"])
  },
  methods: {
    cancelEditAddress() {
      this.setEditForm();
    },
    saveEditAddress() {},
    async editAddress() {
      this.edit_form.store_id = this.store_detail.store.store_id;
      this.edit_form.store_address_th = this.store_detail.store.store_address_th;
      this.edit_form.store_address_en = this.store_detail.store.store_address_en;
      this.edit_form.store_address_cn = this.store_detail.store.store_address_cn;
      this.edit_form.store_district_id = this.store_detail.store_district.district_id;
      this.edit_form.store_province_id = this.store_detail.store_province.province_id;
      this.edit_form.store_sub_district_id = this.store_detail.store_sub_district.sub_district_id;
      this.edit_form.store_zipcode_id = this.store_detail.store_zipcode.zipcode_id;
      this.edit_form.store_lat = this.store_detail.store.store_lat;
      this.edit_form.store_long = this.store_detail.store.store_long;
      this.edit_form.store_note = this.store_detail.store.store_note;

      this.address_dialog = true;
      this.loading = true;
      this.loading = await this.getSelectLocation();
    },
    async getSelectLocation() {
      await this.$store.dispatch("fetchProvinceBack/getProvinceList");
      if (this.edit_form.store_province_id != null) {
        this.$store.dispatch(
          "fetchProvinceBack/getDistrictList",
          this.edit_form.store_province_id
        );
      }
      if (this.edit_form.store_district_id != null) {
        this.$store.dispatch(
          "fetchProvinceBack/getSubDistrictList",
          this.edit_form.store_district_id
        );
      }
      if (this.edit_form.store_district_id != null) {
        this.$store.dispatch(
          "fetchProvinceBack/getZipCodeList",
          this.edit_form.store_district_id
        );
      }
      return false;
    },
    setEditForm() {
      this.edit_form = {
        store_id: null,
        store_address_th: null,
        store_address_en: null,
        store_address_cn: null,
        store_district_id: null,
        store_province_id: null,
        store_sub_district_id: null,
        store_zipcode_id: null,
        store_lat: null,
        store_long: null,
        store_note: null
      };
    }
  },
  created() {
    this.setEditForm();
  }
};
</script>

<style scoped>
.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}
</style>
